// extracted by mini-css-extract-plugin
export default {"headingRow":"YZzZYhj9pCmMQroqtjih","heading":"SDvmrWO_0r1czBmYJmFr","showErrorsButton":"EYBTsOZa0x2yc0319oXZ","additionalCodesContainer":"nPKIGXwVU5o2NMY7rly1"};